export const scrollToSection = (hash) => {
  if (hash === "#top" || !hash) {
    if (window.__lenis) return window.__lenis.scrollTo(0, { duration: 1.1 });
    return window.scrollTo({ top: 0, behavior: "smooth" });
  }
  if (window.__lenis) return window.__lenis.scrollTo(hash, { offset: -84, duration: 1.2 });
  const el = document.querySelector(hash);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const waLink = (intl, text) =>
  `https://wa.me/${(intl || "").replace(/\D/g, "")}?text=${encodeURIComponent(text || "")}`;

export const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/df61af77-7025-4d23-a83e-a43afaf5e8fc/images/8e77b93f2b6243c1bfb65b87f53138ef1e8de345243b5810a9891590fbb23a6b.jpeg";
export const HUB_ORB_IMG =
  "https://static.prod-images.emergentagent.com/jobs/df61af77-7025-4d23-a83e-a43afaf5e8fc/images/04c0d9ea8cb73ad6e8a8776b0912392bfbf20c5d6cb3989968dc8b5dcc96a91d.jpeg";
